import React from 'react';

import SSVirtualGrid from './virtual-controls/ssVirtualGrid';
import SSVirtualRepeatingPanel from './virtual-controls/ssVirtualRepeatingPanel';
import SSVirtualSingleTab from './virtual-controls/ssVirtualSingleTab';
import VirtualDynamicInput from './VirtualDynamicInput';
import { SS_CONTROL_TYPE } from '../constants/form-manager.constants';

const getVirtualComponent = (props) => {
  const { controlType, children } = props;

  switch (controlType) {
    case SS_CONTROL_TYPE.RADIO_BUTTON_LIST:
    case SS_CONTROL_TYPE.TEXT_BOX:
    case SS_CONTROL_TYPE.CHECK_BOX:
    case SS_CONTROL_TYPE.DATE_BOX:
    case SS_CONTROL_TYPE.NUMERIC_TEXT_BOX:
    case SS_CONTROL_TYPE.FILE_INPUT:
    case SS_CONTROL_TYPE.SCORM_FILE_INPUT:
    case SS_CONTROL_TYPE.TEXT_AREA:
    case SS_CONTROL_TYPE.DROP_DOWN:
    case SS_CONTROL_TYPE.SLIDER:
    case SS_CONTROL_TYPE.AI_SUMMARY: {
      return <VirtualDynamicInput {...props} />;
    }

    case SS_CONTROL_TYPE.GRID:
      return <SSVirtualGrid {...props} />;
    case SS_CONTROL_TYPE.REPEATING_PANEL:
      return <SSVirtualRepeatingPanel {...props} />;
    case SS_CONTROL_TYPE.SINGLE_TAB:
      return <SSVirtualSingleTab {...props} />;

    default:
      return children ?? null;
  }
};

export default getVirtualComponent;
